import React, { useContext } from 'react'

import { VegaEditorContext } from '../../../VegaEditorContext'
import {
  CategoricalAxisConfig,
  ColorConfig,
  InteractiveFilter,
  NumericAxisConfig,
  StacksConfig,
  useValidateFields
} from './components'

import { getDataId } from './configUtils'
import {
  clrDefaultMarkFill,
  clrDefaultMarkStroke,
  clrDefaultHoverFill,
  clrDefaultHoverStroke,
} from './defaultValues'

export const defaultStackedBar = {
  b: {
    domain: {
      show: true
    },
    grid: {
      show: false
    },
    ticks: {
      show: false
    },
    label: {
      angle: -45,
      align: 'right'
    }
  },
  v: {
    domain: {
      show: true
    },
    grid: {
      show: true
    },
    ticks: {
      show: true
    }
  },
  tt: {
    show: true,
    format: ',.0f'
  },
  color: {
    mark: {
      stroke: clrDefaultMarkStroke,
      fill: clrDefaultMarkFill
    },
    hover: {
      stroke: clrDefaultHoverStroke,
      fill: clrDefaultHoverFill
    }
  }
}

// Assign labels for each of the items we can configure with color.
const colorTypes = [
  {
    val: 'hover',
    label: 'Hover'
  }
]

const fieldProps = ['b', 's', 'v', 'iflt']

export const StackedBarConfig = () => {
  const { config } = useContext( VegaEditorContext )
  const curDataId = getDataId( config, fieldProps )

  useValidateFields( fieldProps )

  return (
    <div  className="cp-ctls" >
      <CategoricalAxisConfig
        prop="b"
        label="Bars"
        defaultProps={defaultStackedBar}
        validDataset={curDataId}
      />

      <StacksConfig
        prop="s"
        label="Stacks"
        defaultProps={defaultStackedBar}
        validDataset={curDataId}
      />

      {/*
        // Use this to restrict numeric fields to those that seem appropriate
        // for aggregation.
        <NumericAxisConfig
          prop="v"
          label="Values"
          defaultProps={defaultBar}
          restrictions={['canAggregate']}
          validDataset={curDataId}
        />
      */}

      <NumericAxisConfig
        prop="v"
        label="Values"
        defaultProps={defaultStackedBar}
        validDataset={curDataId}
      />

      <ColorConfig
        validDataset={curDataId}
        staticTypes={colorTypes}
      />

      <InteractiveFilter prop="iflt" />

    </div>
  )
}
//
// BarConfig.propTypes = {
//   dataSets: PropTypes.object.isRequired,
//   config: PropTypes.object.isRequired,
//   onUpdate: PropTypes.func.isRequired
// }
